/* =========================================================================
   SENOGARA — design system tokens
   Black / gold luxury identity. These values are final; see HANDOFF.md §9.
   ========================================================================= */

export const COLORS = {
  black: "#0A0A0A",
  blackSoft: "#141414",
  blackCard: "#1B1B1B",
  blackCard2: "#202020",
  gold: "#C9A227",
  goldBright: "#E8C77E",
  goldDim: "#8A6D2F",
  cream: "#F5F0E6",
  creamDim: "rgba(245,240,230,0.6)",
  creamFaint: "rgba(245,240,230,0.38)",
  line: "rgba(201,162,39,0.18)",
  lineFaint: "rgba(245,240,230,0.09)",
  green: "#4CAF6D",
  red: "#B4453F",
};

/* The bottom nav's height: 1px border + 12px padding + 46px of content + 12px
   padding, plus whatever the device reserves for its home indicator.

   BottomNav applies this as its own minHeight and Toast positions itself above
   it, so the two cannot drift apart. They did: the toast used a flat 90px that
   ignored the safe-area inset, which put it behind the nav on every iPhone
   with a home indicator while looking fine on every desktop. */
export const NAV_CLEARANCE = "calc(71px + env(safe-area-inset-bottom))";

export const FONT_IMPORT =
  "@import url('https://fonts.googleapis.com/css2?family=Fraunces:ital,opsz,wght@0,9..144,400;0,9..144,500;0,9..144,600;0,9..144,700;1,9..144,500&family=Inter:wght@400;500;600;700&family=IBM+Plex+Mono:wght@400;500&display=swap');";

export const FONT_DISPLAY = "'Fraunces', serif";
export const FONT_BODY = "'Inter', sans-serif";
export const FONT_MONO = "'IBM Plex Mono', monospace";
